module.exports = __webpack_public_path__ + "img/consecuencia4.0d7c447d.png";